import { useTranslation } from "react-i18next";
import TextAreaInput from "../../components/TextAreaInput/TextAreaInput";
import CollapsibleBlock from "../../components/CollapsibleBlock/CollapsibleBlock";
import useCollapsibles, {
  ETransactionPageMobileCollapsibles,
} from "../../hooks/useCollapsibles";
import useMobile from "../../hooks/useMobile";

type TransactionNotesType = {
  notes: string;
  onNotesChange: (note: string) => void;
};

const TransactionNotes: React.FC<TransactionNotesType> = ({
  notes,
  onNotesChange,
}) => {
  const {
    collapsiblePreferences,
    updateCollapsible,
    toggleTransactionPageMobileCollapsible,
    isTransactionPageMobileCollapsibleOpen,
  } = useCollapsibles();
  const { isMobile } = useMobile();
  const { t } = useTranslation();

  return (
    <CollapsibleBlock
      title={t("transaction_page.collapsibles.notes.title")}
      badge={
        notes?.trim?.()?.length
          ? t("transaction_page.collapsibles.notes.characters", {
              count: notes?.trim?.()?.length,
            })
          : t("transaction_page.collapsibles.notes.empty_badge")
      }
      open={
        isMobile
          ? isTransactionPageMobileCollapsibleOpen(
              ETransactionPageMobileCollapsibles.NOTES
            )
          : collapsiblePreferences.transactionNotesOpen
      }
      onChange={(isOpen: boolean) => {
        if (isMobile) {
          toggleTransactionPageMobileCollapsible(
            ETransactionPageMobileCollapsibles.NOTES
          );
        } else {
          updateCollapsible({ transactionNotesOpen: isOpen });
        }
      }}
      uppercase
    >
      <TextAreaInput
        placeholder={t("transaction_page.collapsibles.notes.placeholder")}
        onChange={(e) => onNotesChange(e.target.value)}
        value={notes}
        rows={4}
      />
    </CollapsibleBlock>
  );
};

export default TransactionNotes;
